/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterStatScheduleDto } from '../../models/center-stat-schedule-dto';

export interface CenterStatControllerGetCounselingAndTreatmentStat$Params {
  startAt: string;
  endAt: string;
  centerId: string;
}

export function centerStatControllerGetCounselingAndTreatmentStat(http: HttpClient, rootUrl: string, params: CenterStatControllerGetCounselingAndTreatmentStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterStatScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, centerStatControllerGetCounselingAndTreatmentStat.PATH, 'get');
  if (params) {
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterStatScheduleDto>;
    })
  );
}

centerStatControllerGetCounselingAndTreatmentStat.PATH = '/api/center-stat/all-schedule';
